export const TEST_ID = 'mapControlResetPopup';

export const ACTION_BUTTON_TEST_ID = 'mapControlResetPopupActionButton';

export const CLOSE_BUTTON_TEST_ID = 'mapControlResetPopupCloseButton';
